import Vue from 'vue';
import Vuex from 'vuex';

import getters from '@/store/getters';
import mutations from '@/store/mutations';
import actions from '@/store/actions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    card: { // properties to be exported in the card object
      activeThemeId: '', // ID of the active theme, used externally
      cardId: '', // ID of this specific card design, generated by templatedesigner
      paperId: '', // ID / Name of the paper to use, passed from PDP
      pdfUrl: '', // URL of the final customized card as PDF
      cartImageUrl: '', // URL of the final customized card as Image (first page)
      themes: [], // themes as generated by the templatedesigner
      sides: [], // working copy of the customized card (text, graphic and photo layers)
    },
    tmp: { // state not to be included into the card-data to be exported
      kartendesignerVisible: false,
      isUnsupportedDeviceOrResolution: false,
      printMode: false, // when true, UI elements are hidden (for PDF printing)
      screenshotMode: false, // next to printMode this is set when screenshot images are taken
      activeSideId: '', // ID of the card side which is shown
      activeLayerId: '', // if the user clicked on a layer and the layer options are shown
      // width, height, top, left, … of the active layer.
      // Needed to positioning the layer settings popup (next to the active layer).
      activeLayerBoundingClientRect: {},
      // themeFontColors: [],
      tooltipsVisible: true, // if true tooltips are shown to the user
      layoutModeActive: false, // when true the layout can be edited (layers moved, added)
      texts: { // Texts which are changed under some circumstances
        cartButtonText: 'In den Einkaufswagen',
        cartButtonWithSleeveText: 'In den Einkaufswagen mit Umschlag',
        wishlistButtonText: 'Auf die Merkliste',
        closeButtonText: 'Verwerfen',
      },
      previewVisible: false, // if true the preview layer is shown
      waitingForPdf: false, // True when a PDF has been requested and it is not there yet
      previewImagesLoaded: false, // becomes true when rendered preview images have arrived
      previewImages: { // once preview images are delivered by the server, they are stored here
        // example:
        // 'front': ...,
        // 'inner-left': ...,
      },
      userImages: [], // Images uploaded by the user
      cardObjectSnapshotAsString: '', // stringified version of the card object, to go back to (time-travel)
      scale: 1.0, // the current scale (CSS transform) to display the card
      // windowWidth / windowHeight are being used to show a warning when the
      // used device is too small. This will get updated on every window resize and on start
      windowWidth: 0,
      windowHeight: 0,
    },
  },
  getters,
  mutations,
  actions,
});
